import { render, staticRenderFns } from "./SingleTable.vue?vue&type=template&id=7f621996"
import script from "./SingleTable.vue?vue&type=script&lang=js"
export * from "./SingleTable.vue?vue&type=script&lang=js"
import style0 from "./SingleTable.vue?vue&type=style&index=0&id=7f621996&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports